export default __webpack_public_path__ + "static/media/bottyAi.fffab19c.png";